module.exports = [{"name":"01-couple","orientation":"horizontal"},{"name":"02-ken","orientation":"vertical"},{"name":"03-sara","orientation":"vertical"},{"name":"04-plant","orientation":"vertical"},{"name":"05-numbers","orientation":"horizontal"}]


//////////////////
// WEBPACK FOOTER
// ./src/cards.json
// module id = 46
// module chunks = 0